import React, { FC, useMemo } from 'react';

import { BUTTON_TYPES, EvTag, IEvButtonProps, TAG_STATUS } from '@evinced-private/ui-common';

import { SiteScannerPopup } from '../../../../components/common/site-scanner-popup/SiteScannerPopup';
import { ICollection } from '../../../../interfaces/Collection';
import { IProperty } from '../../../../interfaces/Property';

import './ShowPropertiesButton.scss';

interface IShowPropertiesButtonProps extends Omit<IEvButtonProps, 'children'> {
	collection: ICollection;
	properties: IProperty[];
	buttonChildren: React.ReactNode;
}

const maxNameLength = 25;

export const ShowPropertiesButton: FC<IShowPropertiesButtonProps> = ({
	collection,
	properties,
	buttonChildren
}) => {
	const { name } = collection;
	const title =
		name.length > maxNameLength
			? `${`“${name.slice(0, maxNameLength)}...“`} includes these properties:`
			: `“${name}“ includes these properties:`;
	const propertiesList = useMemo(() => {
		return (
			collection.properties?.map((id) => {
				const property = properties.find((prop) => prop.id === id);

				return (
					<EvTag key={id} status={TAG_STATUS.INFO} text={property?.name ?? id} maxChars={50} />
				);
			}) ?? []
		);
	}, [collection.properties, properties]);

	const onClosePopup = (onClose?: () => void): void => {
		onClose?.();
	};

	return (
		<SiteScannerPopup
			buttons={[{ title: 'Close', onClick: (onClose: () => void) => onClose() }]}
			isCentered
			isBgTransparent
			title={title}
			onClose={onClosePopup}
			popupWidth={480}
			triggerButtonProps={{
				type: BUTTON_TYPES.CUSTOM,
				children: buttonChildren
			}}
		>
			<div className="show-properties-button-list">{propertiesList}</div>
		</SiteScannerPopup>
	);
};
